import axios from 'axios';
import { HTTP_CONFIG } from '@/config/config.js'

const API_BASE_URL = HTTP_CONFIG.API_BASE_URL; 

export const createPointMessage = (data) => {
  return axios.post(`${API_BASE_URL}traffic/create_point_message/`, data);
}; 

// 新增：获取点位列表
export const queryPointMessage = (params) => {
  return axios.get(`${API_BASE_URL}traffic/query_point_message/`, { params });
}; 

// 新增：获取处理流程列表
export const queryProcessMessage = (params) => {
  return axios.get(`${API_BASE_URL}traffic/query_process_message/`, { params });
}; 

// 新增：违规信息查询
export const queryViolations = (params) => {
  return axios.get(`${API_BASE_URL}traffic/query_violations/`, { params });
};

// 新增：创建违规信息
export const createViolation = (data) => {
  return axios.post(`${API_BASE_URL}traffic/create_violation/`, data);
}; 

// 新增：创建维修信息
export const createMaintenance = (data) => {
  return axios.post(`${API_BASE_URL}traffic/create_maintenance/`, data);
};

// 新增：查询维修信息
export const queryMaintenance = (params) => {
  return axios.get(`${API_BASE_URL}traffic/query_maintenance/`, { params });
}; 